var React = require('react');

function ProcoreLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Procore_Logo_Graphicmark_1C_Black_RGB"),React.createElement("path",{"id":"PROCORE_GRAPHICMARK","data-name":"PROCORE GRAPHICMARK","d":"M108,81.17V92.26a13.52,13.52,0,0,1-14,14H50a13.52,13.52,0,0,1-14-14V51.74a13.52,13.52,0,0,1,14-14H94a13.52,13.52,0,0,1,14,14V62.83H91.6L84.46,50.51H59.54L47.09,72,59.54,93.49H84.46L91.6,81.17ZM65.25,60.35,58.49,72l6.76,11.65h13.5L85.5,72,78.75,60.35Z","transform":"translate(-36 -37.78)","key":1})]);
}

ProcoreLogo.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 72 68.44"};

module.exports = ProcoreLogo;

ProcoreLogo.default = ProcoreLogo;
